import { computed, inject } from 'vue';
import { getDesignSet, designSetToCssVars, heroUsesImage } from '@/lib/designSets';

/**
 * Composable to access the active design set in any page/component.
 *
 * The design set ID is provided by AppLayout and injected via Vue's provide/inject.
 * Pages use this to get CSS variables and conditional rendering flags.
 */
export function useDesignSet() {
    const designSetId = inject('designSetId', 1);

    const designSet = computed(() => getDesignSet(designSetId));
    const cssVars = computed(() => designSetToCssVars(designSet.value));
    const isImageHero = computed(() => heroUsesImage(designSet.value));
    const setName = computed(() => designSet.value.name);
    const isClassic = computed(() => designSet.value.name === 'classic');
    const hasDepth = computed(() => designSet.value.animations.depth !== 'none');
    const hasGlow = computed(() => parseFloat(designSet.value.hero.glowIntensity) > 0.1);
    const hasGlass = computed(() => parseFloat(designSet.value.cards.glassBlur) > 0);

    return {
        designSetId,
        designSet,
        cssVars,
        isImageHero,
        setName,
        isClassic,
        hasDepth,
        hasGlow,
        hasGlass,
    };
}
